/* Hero Carousel — Navail
   Drop this file in /assets/section-hero-carousel.js
   Vanilla JS, no dependencies. Supports multiple instances per page. */
(function () {
  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
    if (slides.length < 2) return;

    var prevBtn = root.querySelector("[data-prev]");
    var nextBtn = root.querySelector("[data-next]");
    var autoplay = root.getAttribute("data-autoplay") === "true";
    var interval = parseInt(root.getAttribute("data-interval"), 10) || 5000;
    var index = 0;
    var timer = null;
    var paused = false;

    function show(newIndex) {
      slides[index].classList.remove("is-active");
      index = (newIndex + slides.length) % slides.length;
      slides[index].classList.add("is-active");
    }

    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () {
        if (!paused) next();
      }, interval);
    }
    function stop() { if (timer) clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener("click", function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener("click", function () { next(); start(); });

    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });

    start();
  }

  function initAll() {
    document.querySelectorAll("[data-hero-carousel]").forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-init when a new instance is added via the theme editor (e.g. section reload).
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector("[data-hero-carousel]");
    if (el) initCarousel(el);
  });
})();